module.exports = __webpack_public_path__ + "img/drone.9f70dedc.jpg";